module.exports = "#cuadro-redondo {    \r\n    padding: 5px; \r\n    width: 80px;\r\n    height: 100px; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cabezera/cabezera.component.css
// module id = ./src/app/cabezera/cabezera.component.css
// module chunks = main